export default (function (_ref) {
  var sizes = _ref.sizes;
  var gutterWidth = sizes.gutterWidth;
  return {
    Row: {
      display: 'flex',
      flexFlow: 'row wrap'
    },
    Padded: {
      marginRight: "-".concat(gutterWidth, "px"),
      marginLeft: "-".concat(gutterWidth, "px"),
      paddingRight: "".concat(gutterWidth, "px"),
      paddingLeft: "".concat(gutterWidth, "px")
    }
  };
});